import { boxShadows } from '@eversports/design-tokens/box-shadows'
import Box from '@eversports/klimt-primitives/legacy/Box'
import Svg from '@eversports/klimt-primitives/legacy/Svg'

import PlusIcon from '../../../../assets/icons/add.svg'

const ShowMoreButton = () => {
  return (
    <Box
      sx={{ backgroundColor: 'midnight', borderRadius: 10, filter: `drop-shadow(${boxShadows.default})` }}
      marginLeft={-2}
      zIndex={2}
    >
      <Svg src={PlusIcon} width={22} height={22} color="white" />
    </Box>
  )
}

export default ShowMoreButton
